// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5d-2";
export var blackBorderOnHover = "_5d-7";
export var cell = "_5d-6";
export var cellContainer = "_5d-3";
export var checked = "_5d-8";
export var disabled = "_5d-5";
export var featuredIconCellContainer = "_5d-9";
export var featuredIconTextContainer = "_5d-b";
export var featuredIconWrapper = "_5d-a";
export var noBorder = "_5d-c";
export var orangeSelectedRow = "_ea-3";
export var overflowableText = "_5d-0";
export var overflowableTextContainer = "_5d-1";
export var row = "_5e-0";
export var rowCheckboxCell = "_5d-4";
export var selectableTable = "_ea-2";